module.exports = __webpack_public_path__ + "img/fi.6fa0d965.svg";